import { render, staticRenderFns } from "./Release.vue?vue&type=template&id=84cf097c"
import script from "./Release.vue?vue&type=script&lang=js"
export * from "./Release.vue?vue&type=script&lang=js"
import style0 from "./Release.vue?vue&type=style&index=0&id=84cf097c&prod&lang=scss"
import style1 from "./Release.vue?vue&type=style&index=1&id=84cf097c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports